import { useEffect, useRef } from 'react';
import { LoadingOverlay } from 'layout/loading-overlay';
import { animated, useSpring } from 'react-spring';
import { useNotification } from 'context/notification.context';
import { useTheme } from 'styled-components';
import { Typography } from 'core/typography';
import useResizeObserver from 'use-resize-observer/polyfilled';
import { legacyTheme } from 'styles/theme';
import { StyledNotificationsManager } from './notifications-manager.styles';

export const NotificationsManager = () => {
  const {
    hideNotification,
    isError,
    message,
    messageTx,
    preloaderVisible,
    timeout,
    visible,
  } = useNotification();

  const theme = useTheme();

  const textContainerRef = useRef();
  const { height } = useResizeObserver({ ref: textContainerRef });

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        hideNotification();
      }, timeout ?? 3000);
    }
  });

  const spring = useSpring({
    config: {
      duration: 300,
      friction: 500,
      tension: 500,
    },
    from: { height: 0 },
    to: {
      height: visible ? Math.max((height || 0) + 12, 40) : 0,
    },
  });

  return (
    <animated.div style={spring}>
      <StyledNotificationsManager
        style={{
          ...spring,
          backgroundColor: isError
            ? legacyTheme.colors.red
            : legacyTheme.colors.blue,
        }}
      >
        <div ref={textContainerRef}>
          {(messageTx || message) && (
            <Typography color="white" text={message} tx={messageTx} />
          )}
        </div>
      </StyledNotificationsManager>

      {preloaderVisible && <LoadingOverlay />}
    </animated.div>
  );
};
